/**
 * Onay kaydı — sürüm damgalı.
 *
 * Eski kod yalnızca 'accepted' / 'essential' yazıyordu; kullanıcının HANGİ
 * metne onay verdiği kayıtlı değildi. Metin değişince eski onay sessizce
 * geçerli sayılıyordu — uyumluluk açısından yanlış.
 *
 * Burada onay; bölge, belge sürümü ve zaman damgasıyla saklanır. Belge sürümü
 * artınca kayıt eskimiş sayılır ve onay yeniden sorulur.
 */

import type { RegionCode } from './documents.ts';

const KEY = 'tekoffice_consent';

export type ConsentChoice = 'accepted' | 'necessary_only';

export interface ConsentRecord {
  choice: ConsentChoice;
  region: RegionCode;
  /** Onay verilen belgenin sürümü. Belge sürümü bunun üstüne çıkarsa yeniden sorulur. */
  documentVersion: number;
  at: string;
}

function safeRead(): ConsentRecord | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<ConsentRecord>;
    if (!parsed || typeof parsed.documentVersion !== 'number' || !parsed.choice) return null;
    return parsed as ConsentRecord;
  } catch {
    // Gizli sekme, kapalı depolama, bozuk JSON — hepsi "onay yok" demektir
    return null;
  }
}

export function readConsent(): ConsentRecord | null {
  return safeRead();
}

export function saveConsent(record: ConsentRecord): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(record));
  } catch {
    // Depolama yazılamıyorsa banner her açılışta görünür — güvenli taraf bu
  }
}

export function clearConsent(): void {
  try { localStorage.removeItem(KEY); } catch { /* yoksay */ }
}

/**
 * Banner gösterilmeli mi?
 * Onay yoksa, başka bölge içinse veya belge sürümü ilerlediyse evet.
 */
export function needsConsent(region: RegionCode, currentVersion: number): boolean {
  const rec = safeRead();
  if (!rec) return true;
  if (rec.region !== region) return true;
  return rec.documentVersion < currentVersion;
}
